import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import { loadFonts } from './vuetify/webfontloader';
import { vuetify } from './vuetify/vuetify';
import i18n from './i18n/i18n';

const app = createApp(App);

loadFonts();

app.use(vuetify);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.mount('#app');
